"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Header;

var _react = _interopRequireDefault(require("react"));

require("./header.scss");

var _lilwLogoWhite = _interopRequireDefault(require("./images/lilw-logo-white.png"));

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Header(_ref) {
  var a11y_heading_desc = _ref.a11y_heading_desc;
  return /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement("h1", {
    className: "a11y-hidden"
  }, "Legal Innovation Lab Wales - ".concat(a11y_heading_desc)), /*#__PURE__*/_react.default.createElement("nav", {
    className: "navbar navbar-expand-lg"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement("a", {
    className: "navbar-logo university-logo",
    href: "https://swansea.ac.uk"
  }, /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: "https://intranet.swan.ac.uk/cdn/suds/images/logo/application-custom/logo-white-en.svg",
    type: "image/svg+xml"
  }), /*#__PURE__*/_react.default.createElement("img", {
    alt: "Swansea University",
    src: "https://intranet.swan.ac.uk/cdn/suds/images/logo/application-custom/logo-white-en.png",
    srcSet: "https://intranet.swan.ac.uk/cdn/suds/images/logo/application-custom/logo-white-en@2x.png"
  })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement("a", {
    className: "navbar-logo lilw-logo",
    href: "https://legaltech.wales"
  }, /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Legal Innovation Lab Wales",
    src: _lilwLogoWhite.default
  }))))))));
}